import { render } from "./Consent.vue?vue&type=template&id=510f5828&scoped=true"
import script from "./Consent.vue?vue&type=script&lang=js"
export * from "./Consent.vue?vue&type=script&lang=js"

import "./custom-consent.scss?vue&type=style&index=0&id=510f5828&lang=scss&scoped=true"
import "./custom-login.scss?vue&type=style&index=1&id=510f5828&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-510f5828"]])

export default __exports__